module.exports = __webpack_public_path__ + "media/julio_weighted_interaction.c260e41f.mp4";